import { AnalyticsBrowser } from "@segment/analytics-next";
export const analytics = AnalyticsBrowser.load({
  writeKey: process.env.SEGMENT_KEY as string,
});
